import React,{useState} from 'react';
import { Route, Switch ,useRouteMatch,Redirect,useLocation,NavLink,useParams } from 'react-router-dom'
import * as Components from '../components';
import * as Utils from '../utils';
import InfiniteScroll from 'react-infinite-scroller';
import {Container,Row,Col,Image, Alert} from 'react-bootstrap';
import {Parser} from 'html-to-react';
import { Label } from 'react-bootstrap';
function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

function Detail() {
    let { topicId } = useParams();
    let query = useQuery();
    let [content,SetContent]=useState('Loading...');
    let [data,setData] = useState(null)
    const key = query.get('key');

    const loadNewspaper=()=>{
        Utils.clientNoauthPost(`/Newspaper/GetNewspaperDetails?id=${topicId}`).then(r=>{
            SetContent(r.content)
            window.scrollTo(0, 0)
        })
    }
    const loadbttc=()=>{
        Utils.clientNoauthPost(`/Symbol/GetSymbolContentNews?id=${topicId}`).then(r=>{
            setData(r)
            window.scrollTo(0, 0)
        })
    }

    React.useEffect(()=>{
        console.log('here')
        if(key==='bcpt'){
            loadbttc()
        }else{
            loadNewspaper()
        }
       
    },[topicId])

    let p = new Parser();
    if(key!=='bcpt')
        return <div className='news-content'>{p.parse(content)}</div>   

    if(data==null)
        return <div>....</div>
    document.title = `${data.symbol}: ${data.title}`
    let sContent = JSON.parse(data.content);
    console.log(sContent)
    if(sContent.type !=2 ){
        return<div className="bcpt-content">
            <h3>{data.symbol}: {data.title}</h3>
            <h5 className="news-item-date">{Utils.formatHour(data.upTime)}</h5>
            {
                sContent.texts.map((e,i)=>(
                    <div key={i}>
                        {p.parse(e)}
                    </div>
                ))
            }
            <div>Tài liệu:</div>
            {
                sContent.links.map((e,i)=>(
                    <div key={i}>
                        <a href={e.link} target="_blank" rel="noopener noreferrer" download>
                            {e.text}
                        </a>
                    </div>
                ))
            }
        </div>
    }
    return <div className='news-content'>{p.parse(data.content)}</div>   
}

const Item=({item,isList,type} )=>{
    return<div className="news-item">
        {
            type!=='bcpt'&&<div className="news-item-img">
                <Image src={item.avatar||Utils.getCompanyLogo(item.symbol)} fluid/>
            </div>
        }
        <div className={!isList?"news-item-content2":"news-item-content"}>
            <h4 className="news-item-title">{item.title}</h4>
            <h5 className="news-item-date">{Utils.formatHour(item.upTime)}</h5>
        </div>
    </div>
}
const TinMoi=({item})=>{
    let match = useRouteMatch();
    let location = useLocation();
    const [data,setData] = React.useState([
        {title:'Báo cáo phân tích',lkey:'bcpt',data:[]},
        {title:'Chứng khoán',lkey:'chungkhoan',data:[]},
        {title:'Thế giới',lkey:'thegioi',data:[]},
        {title:'BĐS',lkey:'bds',data:[]},
        {title:'Thị trường',lkey:'thitruong',data:[]},
        {title:'Vĩ mô',lkey:'vimo',data:[]},
    ])
    React.useEffect(()=>{
        Utils.clientNoauthPost(item.url).then(r=>{
            setData([
             {title:'Báo cáo phân tích',lkey:'bcpt',data:r.bcpt},
             {title:'Chứng khoán',lkey:'chungkhoan',data:r.chungkhoan},
             {title:'Thế giới',lkey:'thegioi',data:r.thegioi},
             {title:'BĐS',lkey:'bds',data:r.bds},
             {title:'Thị trường',lkey:'thitruong',data:r.thitruong},
             {title:'Vĩ mô',lkey:'vimo',data:r.vimo},
            ]) 
         }).catch(e=>{
         })
    },[])
    let isList = location.pathname===match.path
    console.log(data)
    return <div>
        {
            data.map(e=><div key={e.lkey}>
                <Alert variant='dark' >{e.title}</Alert>
                {
                    e.data.map((el,i)=><NavLink 
                        className={isList?'':'list-left'}
                        key={i} 
                        to={`${match.path}/${el.id}?key=${e.lkey}`}>
                            <Item item={el} isList={isList} type={e.lkey} />
                        </NavLink>)
                }
            </div>)
        }
    </div>
}
const ListItem=({data})=>{
    let match = useRouteMatch();
    let location = useLocation();

    let [page,SetPage] = useState(0);
    let [items,SetItems] = useState([]);
    let [isLoading,setIsLoading] = useState(false);
    let [isLoadMore,setIsLoadMore] = useState(true);
    
    const _last = React.useRef(0);

    const loadMore = ()=>{
        if(isLoading || !isLoadMore) 
            return;
        setIsLoading(true);
        Utils.clientNoauthPost(data.url + _last.current).then(r=>{
            console.log(r)
            if(r.length===0){
                setIsLoadMore(false);
                return;
            }
            SetPage(page+1)
            SetItems([...items,...r])
            setIsLoading(false);
            _last.current = r[r.length-1].id;
        }).catch(e=>{
            setIsLoading(false);
        })
    }

    let isList = location.pathname===match.path;
    
    return <Container>
            <Row >
                <Col md={isList?0:8} xs={12} >
                    <Route path={`${match.path}/:topicId`}>
                        <Detail />
                    </Route>
                </Col>
                <Col md={isList?12:4} xs={12} className={'list-news-contain'}>
                    {
                        data.type==1?<TinMoi item={data}/>:<InfiniteScroll
                        className="list-news"
                        pageStart={0}
                        loadMore={loadMore}
                        hasMore={isLoadMore}
                        loader={<div className="loader" key={0}>Loading ...</div>}
                        useWindow={false}
                        >
                        {
                            items.map(e=><NavLink 
                                className={isList?'':'list-left'}
                                key={e.id} to={`${match.path}/${e.id}?key=${data.lkey}`}>
                                    <Item item={e} isList={isList} type={data.lkey} />
                                </NavLink>)
                        } 
                    </InfiniteScroll>
                    }
                </Col>
            </Row>
        </Container>
}

const Screen=(props)=>{
    let match = useRouteMatch();
    const menus = [
        {href:'/tin-moi', title:'Tin mới',url:'/Newspaper/GetLatest',type:1},
        {href:'/chung-khoan', title:'Chứng khoán',url:'/Newspaper/GetNewspaper?type=1,2,3,5&last='},
        {href:'/bao-cao-phan-tich', title:'Báo cáo PT',url:'/Newspaper/GetBCTC?last=',lkey:'bcpt'},
        {href:'/the-gioi', title:'Thế giới',url:'/Newspaper/GetNewspaper?type=8&last='},
        {href:'/bat-dong-san', title:'Bất Động Sản',url:'/Newspaper/GetNewspaper?type=4&last='},
        {href:'/thi-truong', title:'Thị trương',url:'/Newspaper/GetNewspaper?type=9,10&last='},
        {href:'/vi-mo', title:'Vĩ mô',url:'/Newspaper/GetNewspaper?type=7&last='},
    ]
    return <>
        <Components.SubMenu menus={menus} />
        <Switch>
            <Route exact path={match.path} >
                <Redirect from={match.path} to={`${match.path}${menus[0].href}`} />
            </Route>
            {
                menus.map((e,i)=><Route
                    exact={e.exact}
                    key={i}
                    path={`${match.path}${e.href}`}
                >
                        <ListItem
                            data={e}
                        />
                    </Route>
                )
            }
        </Switch>
    </>
}
export default Screen;